import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const KOREA_TZ = "Asia/Seoul";

/**
 * API 요청용: 화면에 선택한 시각을 한국 표준시로 간주해 naive ISO 문자열로 반환.
 * (toISOString() 사용 시 UTC로 바뀌어 날짜가 하루 밀리는 문제 방지)
 */
export function toKoreaApiDateTime(input) {
	if (input == null) return null;
	const d = dayjs.isDayjs(input) ? input : dayjs(input);
	if (!d.isValid()) return null;
	const wall = d.format("YYYY-MM-DD HH:mm:ss");
	return dayjs.tz(wall, KOREA_TZ).format("YYYY-MM-DDTHH:mm:ss");
}

/**
 * API 응답 파싱: 타임존 표기가 없으면 한국 시간으로 해석.
 */
export function parseKoreaDateTime(s) {
	if (s == null || s === "") return dayjs(null);
	const raw = String(s).trim();
	const hasExplicitTz =
		/[zZ]$/.test(raw) || /[+-]\d{2}:\d{2}$/.test(raw);
	if (hasExplicitTz) return dayjs(raw);
	const normalized = raw.includes("T") ? raw : raw.replace(" ", "T");
	return dayjs.tz(normalized, KOREA_TZ);
}
